module.exports = __webpack_public_path__ + "img/2023-01-09e_2.21961bb2.jpg";